(function () {
  'use strict';

  /* @ngdoc object
   * @name main.edit
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main.submain.edit', [
      'ui.router'
    ]);
}());
